import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 15, fontSize: 10 },
  section: { marginBottom: 10 },
  heading: {
    fontSize: 16,
    marginBottom: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  subheading: {
    fontSize: 13,
    marginBottom: 6,
    fontWeight: 'bold',
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 6,
  },
  tableRow: {
    flexDirection: "row"
  },
  cellHeader: {
    margin: 5,
    padding: 5,
    fontWeight: "bold",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    flex: 1,
    backgroundColor: '#e4e4e4'
  },
  cell: {
    margin: 5,
    padding: 5,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    flex: 1,
  },
  descriptionCell: {
    margin: 5,
    padding: 5,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    flex: 2, // make it wider than others
  }

});

const MultiVendorEnquiryPDF = ({ vendors }) => (
  <Document>
    {Array.isArray(vendors) && vendors.length > 0 &&
      vendors.map((vendor, index) => (
        <Page key={index} size="A4" style={styles.page}>
          {/* Heading */}
          <View style={styles.section}>
            <Text style={styles.heading}>RFQ (Request for Quotation)</Text>
            {/* <Text>Date: {new Date().toLocaleDateString()}</Text> */}
            <Text>
              Date: {new Date().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              })}
            </Text>

          </View>

          {/* Receiver Info */}
          <View style={styles.section}>
            <Text style={styles.subheading}>To:</Text>
            <Text>{vendor.receivername}</Text>
            <Text>{vendor.receivercompanyname}</Text>
            {vendor.receivercompanyaddress && <Text>{vendor.receivercompanyaddress}</Text>}
          </View>

          {/* Subject */}
          <View style={styles.section}>
            <Text style={styles.subheading}>Subject:</Text>
            <Text>Request for Quotation for Materials</Text>
          </View>

          {/* Body */}
          <View style={styles.section}>
            <Text>Dear Sir/Madam,</Text>
            <Text style={{ marginTop: 5 }}>
              We kindly request you to share your best quotation for the following materials. Please include delivery time, payment terms, applicable taxes and  terms & conditions. Kindly send your quote within 7days.
            </Text>
          </View>

          {/* Table */}
          <View style={styles.section}>
            <Text style={{ marginBottom: 5 }}>Required Materials:</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.cellHeader}>Material Code</Text>
                <Text style={[styles.cellHeader, styles.descriptionCell]}>Description</Text>
                <Text style={styles.cellHeader}>Quantity</Text>
                <Text style={styles.cellHeader}>Unit</Text>
                <Text style={styles.cellHeader}>Remarks</Text>
              </View>

              {vendor.materials.map((item, idx) => (
                <View style={styles.tableRow} key={idx}>
                  <Text style={styles.cell}>{item.code}</Text>
                  <Text style={[styles.cell, styles.descriptionCell]}>{item.description}</Text>
                  <Text style={styles.cell}>{item.requested}</Text>
                  <Text style={styles.cell}>{item.uom}</Text>
                  <Text style={styles.cell}>{item.remarks}</Text>
                </View>
              ))}
            </View>
          </View>

          {/* Footer */}
          <View style={styles.section}>
            <Text>Thank you,</Text>
            <Text style={{ marginTop: 4 }}>{vendor.sendername}</Text>
            <Text>{vendor.sendercompany}</Text>
          </View>
        </Page>
      ))}
  </Document>
);

export default MultiVendorEnquiryPDF;
